export const RX = {
    RUN_AUTHORIZATION_CODE_FLOW: 'authentication:run-authorization-code-flow',
    RUN_CALLBACK_FLOW: 'authentication:run-callback-flow',
    DISPLAY_TOKENS: 'authentication:display-tokens'
};
